export default {
  form: {
    should_save_payment_info: {
      label: 'Enregistrer les infos de paiement pour un paiement plus rapide',
    },
  },
};
